module.exports = __webpack_public_path__ + "img/tic-tok-icon.ec755bf.png";